import { useState } from "react";

import type { DrawingCollectionRow } from "../drawings-collection.lib";
import { findDrawingById } from "../drawings-collection.lib";

type UseDrawingsCollectionModalsParams = {
  disabledRight?: boolean;
  selectedCount: number;
  selectedDrawingId?: string;
  drawings: DrawingCollectionRow[];
};

export const useDrawingsCollectionModals = ({ disabledRight, selectedCount, selectedDrawingId, drawings }: UseDrawingsCollectionModalsParams) => {
  const [isBindOpen, setIsBindOpen] = useState(false);
  const [isRenameOpen, setIsRenameOpen] = useState(false);
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);
  const [isInfoOpen, setIsInfoOpen] = useState(false);

  const openBindModal = () => {
    if (disabledRight || selectedCount === 0) {
      return;
    }

    setIsBindOpen(true);
  };

  const openRenameModal = () => {
    if (disabledRight || selectedCount !== 1) {
      return;
    }

    setIsRenameOpen(true);
  };

  const openDeleteModal = () => {
    if (disabledRight || selectedCount === 0) {
      return;
    }

    setIsDeleteOpen(true);
  };

  const openInfoModal = () => {
    if (selectedCount !== 1) {
      return;
    }

    if (!findDrawingById(drawings, selectedDrawingId)) {
      return;
    }

    setIsInfoOpen(true);
  };

  return {
    isBindOpen,
    setIsBindOpen,
    isRenameOpen,
    setIsRenameOpen,
    isDeleteOpen,
    setIsDeleteOpen,
    isInfoOpen,
    setIsInfoOpen,
    openBindModal,
    openRenameModal,
    openDeleteModal,
    openInfoModal,
  };
};
